/*
 * @Author: bbqin
 * @Date: 2023-02-14 15:10:49
 * @LastEditTime: 2023-07-24 13:59:54
 * @LastEditors: bbqin
 * @Description: 如果我没写，可能我忘了。如果我忘了，可能我没看。如果我没看，可能我没写。
 * @FilePath: \Platform_Front\src\platform\components\SmartCard\components\cardList\index.js
 * (混沌)足够多的方案才能接近真实的结果。
 */
import React, { Component, Fragment } from 'react';
import { BaseComponent } from '@platform/template';
import { Tooltip } from '@platform/base';
// import useCardList from './store';
import { toast, getSysFieldid } from '@platform/api';
import SingleCard from '../card/index';
// import Dnd from '../../libs/dnd';  // Dnd版本有问题  先换成另外一个
import BeautifulDnd from '../../libs/beautiful-dnd';
import CardWallet from '../wallet';
import { isFunction, Closest } from '../../libs/utils';
import classNames from 'classnames';
import useAffix from '../useAffix';

require('./index.less');

const CardWalletHOC = useAffix(CardWallet);

const defaultProps = {
    prefixCls: 'card-list',
    name: 'CardList',
    // 页签下空数据样式
    panelEmptyContent: null,
    // 是否可拖拽
    draggable: true,
    // 卡片组
    walletConfig: {
        emptyContent: null,
        // 也可以设置某个id下属性
        // walletId: {visible: false}
    },
    // 卡片配置项
    cardConfig: {
        emptyContent: null,
        // 也可以设置某个id下属性
        // cardId: {visible: false}
    },

    // 自动化
    fieldid: 'smart_card_list',
};

class CardList extends Component {
    constructor(props) {
        super(props);
        const { store, list } = props;
    }

    onOutSideWalletClick = e => {
        let {
            store,
            wallets = [],
        } = this.props;
        const target = e.target;
        if (!Closest(target, '.card-list-wrapper') || !Closest(target, '.card-wallet-wrapper')) {
            // 避免每次点击都更新
            let shouldUpdate = false;
            // 清除当前页签其他的已选
            wallets.forEach(wallet => {
                const { props = {} } = wallet;
                const { moduleId: currentModuleId } = props;
                const { active } = store.getCardWalletProps(currentModuleId);
                if (active) {
                    store.setCardWalletProps(currentModuleId, 'active', false, false);
                    shouldUpdate = true;
                }
            });
            shouldUpdate && this.forceUpdate();
        }
    }

    componentDidMount() {
        // 保证先执行
        document.addEventListener('mousedown', this.onOutSideWalletClick);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.onOutSideWalletClick);
    }

    getEmptyContent(emptyContent) {
        const { langJson = {}, prefixCls } = this.props;
        const dom = <div className={`${prefixCls}-empty-content`}>
            <i className={`${prefixCls}-empty-img`} />
            <span>{langJson['container-empty-content']}</span>
        </div>;
        return <div className={`${prefixCls}-empty`}>
            {typeof emptyContent === 'function' ? emptyContent() : dom}
        </div>;
    }

    getWalletEmptyContent(emptyContent) {
        const { langJson = {}, prefixCls } = this.props;
        const dom = <div className={`${prefixCls}-wallet-empty-content`}>
            <i className={`${prefixCls}-empty-img`} />
            <span>{langJson['container-empty-content']}</span>
        </div>;
        return <div className={`${prefixCls}-wallet-empty`}>
            {typeof emptyContent === 'function' ? emptyContent() : dom}
        </div>;
    }

    // 拖拽结束
    onDragEnd = (finalData = [], dragItem) => {
        let { id, store } = this.props;
        const tabId = store.getStore(['idRelation', 'tabs', 'moduleId', id]);
        if (tabId) {
            const wallets = store.getStore(['walletLists', tabId]) || [];
            const walletObj = {};
            const nextData = [];
            wallets.forEach(wallet => {
                const { $id } = wallet;
                walletObj[$id] = wallet;
            });
            // 重新整理顺序
            finalData.forEach(wallet => {
                const { $id } = wallet;
                if (walletObj[$id]) {
                    nextData.push(walletObj[$id]);
                    delete walletObj[$id];
                }
            });
            Object.keys(walletObj).forEach(wallet => {
                const { $id } = wallet;
                nextData.push(walletObj[$id]);
            });

            store.setStore(['walletLists', tabId], nextData, true);
            // 触发缓存
            store.setCacheMeta();
        }
    }

    getWalletCard = cards => {
        let {
            store,
            cardStores,
            pageInstance,
            langJson,
            feedbackMessage,
            getPageInstanceByPortal,
            portalPageInstance,
        } = this.props;

        const smartCardModuleId = store.getStore('id');

        // 这里不做wallet的空状态, 如果wallet没有子元素，则wallet直接不显示，再数据层已经做了

        const cardDom = cards.map(card => {
            const { $id, props = {}, path, label } = card;
            const { moduleId } = props;
            const currentCardStore = cardStores[moduleId];
            if (!currentCardStore) {
                console.log('未找到cardStore!');
                return null;
            }

            // 包含cardConfig
            const currentProps = currentCardStore.getCardProps();
            const { visible } = currentProps;

            // 不显示的  不渲染
            if (!visible) {
                return null;
            }

            return <SingleCard
                path={path}
                key={$id}
                id={moduleId}
                store={currentCardStore}
                pageInstance={pageInstance}
                parentStore={store}
                props={currentProps}
                __langJson={langJson}
                __componentName={label}
                smartCardModuleId={smartCardModuleId}
                feedbackMessage={feedbackMessage}
                getPageInstanceByPortal={getPageInstanceByPortal}
                portalPageInstance={portalPageInstance}
            />;
        });

        return cardDom;
    }

    getListItem = (wallet, index, params = {}) => {
        let {
            prefixCls,
            store,
            cardLists,
            draggable,
            wallets = [],
        } = this.props;

        const { $id, props = {}, _isVirtually } = wallet;
        const { moduleId } = props;

        // 包含walletConfig
        const {
            visible,
            title,
            expanded,
            emptyContent,
            onExpand,
            headerRight,
            headerCenter,
            onFilter,
            onRefresh,
            active,
            className = '',
            showHeader = true,
            forceVisible,
            _langText,
            ...others
        } = store.getCardWalletProps(moduleId);

        // 没有子元素或者不显示  渲染一个占位  这样好做拖拽
        if (!visible && forceVisible !== false) {
            return <div className={`${prefixCls}-placeholder`}></div>;
        }

        const langText = _langText || title;

        const cards = cardLists[$id];
        let cardDom = this.getWalletCard(cards);

        return <CardWalletHOC
            {...others}
            visible={visible}
            forceVisible={forceVisible}
            showHeader={showHeader && !_isVirtually}
            className={classNames(` ${className} `, {
                'wallet-draggable': draggable,
                'wallet-virtually': _isVirtually,
            })}
            headerAffix
            active={active}
            title={langText}
            expanded={expanded}
            connectDragSource={params?.connectDragSource}
            onFilter={(...params) => {
                isFunction(onFilter) ? onFilter(moduleId, ...params) : null;
            }}
            onRefresh={(...params) => {
                isFunction(onRefresh) ? onRefresh(moduleId, ...params) : null;
            }}
            headerCenter={(...params) => {
                return isFunction(headerCenter) ? headerCenter(moduleId, ...params) : null;
            }}
            headerRight={(...params) => {
                return isFunction(headerRight) ? headerRight(moduleId, ...params) : null;
            }}
            onExpand={(...params) => {
                store.setCardWalletProps(moduleId, 'expanded', params[0], false);
                isFunction(onExpand) && onExpand(moduleId, ...params);
            }}
            key={$id}
            onActive={(...params) => {
                // console.log(params);
                const active = store.getCardWalletProps(moduleId, 'active');
                // 避免每次点击都更新
                let shouldUpdate = false;
                // 清除当前页签其他的已选
                wallets.forEach(wallet => {
                    const { props = {} } = wallet;
                    const { moduleId: currentModuleId } = props;
                    const { active } = store.getCardWalletProps(currentModuleId);
                    if (currentModuleId !== moduleId && active) {
                        store.setCardWalletProps(currentModuleId, 'active', false, false);
                        shouldUpdate = true;
                    }
                });
                store.setCardWalletProps(moduleId, 'active', true, false);
                if (!active || shouldUpdate) {
                    this.forceUpdate();
                }
            }}
        >{cardDom}</CardWalletHOC>;
    }

    getList() {
        let { wallets = [], store, panelEmptyContent, id, draggable } = this.props;

        // 是否存在强制显隐性的情况 （dom销毁）
        let unForceVisible = false;
        const visibleItems = {};

        const visibleList = wallets.filter(wallet => {
            const { $id, props = {} } = wallet;
            const { moduleId, visible: originVisible } = props;
            const { visible, forceVisible } = store.getCardWalletProps(moduleId);

            // 如果forceVisible是undefined或者true 强制清除dom
            if (forceVisible === false) {
                unForceVisible = true;
            }

            visibleItems[$id] = visible;

            return visible;
        });

        let dom = [];
        if (!visibleList.length) {
            let empty = this.getEmptyContent(panelEmptyContent);
            dom.push(empty);
        }
        if (visibleList.length || unForceVisible) {
            let list = null;
            if (draggable && visibleList.length > 1) {
                list = <BeautifulDnd
                    droppableId={`${id}_beautiful_dnd_id`}
                    items={wallets}
                    onDragEnd={this.onDragEnd}
                    renderItem={this.getListItem.bind(this)}
                    visibleItems={visibleItems}
                />;
            } else {
                list = wallets.map(this.getListItem.bind(this));
            }
            dom.push(list);
        }
        return dom;
    }

    render() {
        let { prefixCls, id, onScroll, fieldid } = this.props;
        return <div
            className={`${prefixCls}-wrapper`}
            id={`CardList_${id}`}
            onScroll={e => isFunction(onScroll) && onScroll(e)}
            fieldid={getSysFieldid(`${id || ''}_${fieldid}`)}
        >{this.getList()}</div>;
    }
}

CardList.defaultProps = defaultProps;
CardList.displayName = 'CardList';
// CardList.useCardList = useCardList;

export default CardList;